<template>
    <ContentLayout>
        <PageTitle title="Paskyros" />

        <Card :pt="{
            body: () => ({
                class: [
                    '!p-0 !rounded-b-lg'
                ]
            })
        }">
            <template #content>
                <DataTable :paginator="isPaginationEnabled"
                           :rows="perPage"
                           :totalRecords="totalUsersCount"
                           :value="usersList"
                           :lazy="true"
                           :loading="isTableLoading"
                           tableStyle="min-width: 50rem"
                           :pt="{
                               tableContainer: () => ({
                                   class: [
                                       '!rounded-xl'
                                   ]
                               })
                           }"
                           @page="onPageChange"
                           size="small"
                >
                    <Column field="first_name" header="Vardas"></Column>
                    <Column field="last_name" header="Pavardė"></Column>
                    <Column field="email" header="El. paštas"></Column>
                    <Column field="role" header="Rolė"></Column>
                    <Column header="Kontaktai">
                        <template #body="{ data }">
                            <div class="flex flex-row gap-2">
                                <Button @click="viewUser(data.id)" class="" severity="secondary" rounded size="small">
                                    Peržiūrėti
                                </Button>

                                <template v-if="is('admin')">
                                    <Button @click="deleteUser(data.id)" class="" severity="secondary" rounded size="small">
                                        Ištrinti
                                    </Button>
                                </template>
                            </div>
                        </template>
                    </Column>
                    <template #empty>Paskyrų nerasta</template>
                </DataTable>
            </template>
        </Card>
    </ContentLayout>
</template>

<script setup lang="ts">
    import { ref, onMounted, watch } from 'vue'
    import { useRouter } from 'vue-router';
    import { apiRequest } from '@/services/axios';
    import { is } from '@/extensions/permissions.ts'

    import { useConfirm } from 'primevue/useconfirm'
    import Button from 'primevue/button';
    import Card from 'primevue/card';
    import DataTable from 'primevue/datatable'
    import Column from 'primevue/column'

    import ContentLayout from '@/components/layouts/Content.vue';
    import PageTitle from '@/components/navigation/PageTitle.vue';

    // Refs and variables
    const confirm = useConfirm();
    const usersList = ref<Array<object>>([]);
    const totalUsersCount = ref<number>(0);
    const perPage = ref<number>(0)
    const isTableLoading = ref<boolean>(false);
    const isPaginationEnabled = ref<boolean>(false);
    const router = useRouter();
    const currentPage = ref<number>(1);

    // Hooks
    onMounted(() => {
        getUsers();
    });

    // Methods
    async function getUsers(page: number = 1)
    {
        isTableLoading.value = true;
        currentPage.value = page;

        const response = await apiRequest(
            'get',
            '/users',
            {},
            {
                params: {
                    page: page
                }
            }
        );

        usersList.value = response.data.data.users.data;
        totalUsersCount.value = response.data.data.total;
        perPage.value = response.data.data.per_page;

        if (response.data.data.last_page > 1) {
            isPaginationEnabled.value = true;
        }

        isTableLoading.value = false;
    }

    function viewUser(userId: number) {
        router.push({ name: 'user', params: { id: userId }})
    }

    async function deleteUser(userId: number) {
        confirm.require({
            message: 'Ar tikrai norite ištrinti šį vartotoją?',
            header: 'Patvirtinimas',
            icon: 'pi pi-exclamation-triangle',
            rejectProps: {
                label: 'Ne',
                severity: 'secondary',
                outlined: true,
            },
            acceptProps: {
                label: 'Taip'
            },
            accept: async () => {
                await apiRequest(
                    'delete',
                    '/users/' + userId
                );

                await getUsers(1);
            }
        });
    }

    // Events
    const onPageChange = (event: any) => {
        currentPage.value = parseInt(event.page + 1);

        getUsers(currentPage.value)
    };
</script>